import React, { Component } from "react";
import PropTypes from "prop-types";
import { PlayerBadge } from "@myplay/ui";
import closeIcon from "../../assets/icons/close-circle.svg";
import EmptyCard from "../EmptyPlayerCard";

import "./teamMemberCard.scss";
import isPlayer from "../../utils/isPlayer";

const avatarBgColors = [
  "#9fa8da",
  "#7986cb",
  "#90caf9",
  "#64b5f6",
  "#81d4fa",
  "#4fc3f7",
  "#80deea",
  "#4dd0e1",
  "#80cbc4",
  "#4db6ac",
  "#a5d6a7",
  "#81c784",
  "#c5e1a5",
  "#aed581",
  "#e6ee9c"
];

class TeamMemberCard extends Component {
  state = {
    hover: false
  };

  MemberCard = () => {
    const { hover } = this.state;
    const { member, handleCardEdit, index, isEditable } = this.props;
    const {
      firstName,
      lastName,
      playerNumber,
      avatar,
      avatarBgColor,
      accountType
    } = member;
    return (
      <div
        className="team-member-card"
        onMouseOver={() => {
          this.setState({ hover: true });
        }}
        onMouseLeave={() => {
          this.setState({ hover: false });
        }}
      >
        {hover &&
          isEditable && (
            <img
              className="team-member-card__delete-icon"
              src={closeIcon}
              onClick={() => {
                handleCardEdit("delete", index);
              }}
            />
          )}
        {avatar ? (
          <img className="team-member-card__avatar" src={avatar} alt="" />
        ) : (
          <div className="team-member-card__avatar">
            <PlayerBadge
              firstName={firstName}
              lastName={lastName}
              color={avatarBgColor || avatarBgColors[index]}
            />
          </div>
        )}
        <div
          className="team-member-card__member-details"
          style={{
            backgroundColor: isPlayer(accountType) ? "black" : "#262323"
          }}
        >
          <p
            className={
              isPlayer(accountType)
                ? "team-member-card__member-details__green-title team-member-card__member-details__green-title--big"
                : "team-member-card__member-details__green-title team-member-card__member-details__green-title--small"
            }
          >
            {isPlayer(accountType) ? playerNumber : accountType}
          </p>
          <p>{firstName}</p>
          <p>{lastName}</p>
        </div>
      </div>
    );
  };
  render() {
    const { member, index, handleCardEdit } = this.props;
    const { firstName } = member;
    return firstName ? (
      this.MemberCard()
    ) : (
      <EmptyCard index={index} handleCardEdit={handleCardEdit} />
    );
  }
}

TeamMemberCard.propTypes = {
  member: PropTypes.object.isRequired
};

export default TeamMemberCard;
